import { TranslationKeys } from '~frontend-common/i18n/english/redirection-to-partner.i18n';

const keys: TranslationKeys = {
  commonRedirectionToPartner: {
    none: 'Aucun partenaire',
    jaLemieux: {
      name: 'Telio Assurances',
    },
    mitchellAbbottGroup: {
      name: 'Mitchell & Abbott Group',
    },
    sgb: {
      name: 'ESSOR Assurances',
    },
    verge: {
      name: 'Assurance Verge',
    },
  },
};

export default keys;
